// Arayüz sözlüğü — 04-copy-and-messaging.md. Kod İngilizce anahtar, değer doğal Türkçe.
export const copy = {
  brand: {
    promise: 'Servisini bekleme. Ne zaman geleceğini bil.',
    alt1: 'Servisin hep gözünün önünde.',
    alt2: 'Servisin. Rotan. Kontrolün.',
    alt3: 'Akıllı servis ulaşımı.',
  },
  actions: {
    track: 'Servisi Takip Et',
    noShow: 'Bugün Binmeyeceğim',
    contactDriver: 'Şoföre Ulaş',
    continue: 'Devam Et',
    requestDemo: 'Demo İste',
    startTrip: 'SERVİSİ BAŞLAT',
    ready: 'Hazırım',
    viewRoute: 'Rotayı görüntüle',
    newAddressRequest: 'Yeni adres talebi',
    retry: 'Tekrar dene',
    undo: 'Geri al',
    confirm: 'Onayla',
    cancel: 'Vazgeç',
    save: 'Kaydet',
    callDriver: 'Şoförü Ara',
  },
  status: {
    onTheWay: 'Servis yolda',
    notStarted: 'Henüz başlamadı',
    approaching: 'Yaklaşıyor',
    arrived: 'Servisiniz durağınızda.',
    onTime: 'Zamanında',
    waitingDriver: 'Şoförden açıklama bekleniyor.',
  },
  states: {
    offline: 'İnternet bağlantısı yok',
    offlineBody: 'Bağlantı gelince otomatik güncellenir.',
    serverError: 'Bir sorun oluştu',
    serverErrorBody: 'Sunucuya ulaşamadık. Birazdan tekrar deneyin.',
    forbidden: 'Bu sayfaya erişiminiz yok',
    forbiddenBody: 'Yetki için yöneticinizle iletişime geçin.',
    empty: 'Kayıt yok',
    gpsLost: 'Araç konumu alınamıyor',
    locationDenied: 'Konum izni gerekli',
    cameraDenied: 'Kamera izni gerekli',
    qrInvalid: 'QR kodu geçersiz',
    vehicleNotFound: 'Araç bulunamadı',
    paymentError: 'Ödeme alınamadı',
    otpError: 'Kod hatalı',
  },
} as const;
